import React from "react";
import PhoneInputWithCountry from "react-phone-number-input";
import "react-phone-number-input/style.css";
import "./phoneInput.css";

const PhoneInput = ({
  value,
  onChange,
  labelname,
  error,
  errmsg,
  disabled,
  required,
  placeholder,
}) => {
  const handleChange = (phoneValue) => {
    // Ensure the value always has + prefix
    if (phoneValue && !phoneValue.startsWith("+")) {
      phoneValue = `+${phoneValue}`;
    }
    onChange && onChange(phoneValue || "");
  };

  // Normalize value - ensure it has + prefix
  const normalizedValue = value && !value.startsWith("+") ? `+${value}` : value;

  return (
    <div className="formdiv inputlabel phone-input-wrapper">
      <div
        className={`phone-input-container
    ${error ? "phone-input-error" : ""}
    ${disabled ? "phone-input-disabled" : ""}
    ${normalizedValue ? "has-value" : ""}
  `}
      >
        {labelname && (
          <label
            className={`phone-label ${required ? "required" : ""} ${
              normalizedValue || placeholder ? "phone-label-shrink" : ""
            }`}
          >
            {labelname}
          </label>
        )}
        <PhoneInputWithCountry
          international
          defaultCountry="US"
          value={normalizedValue || ""}
          onChange={handleChange}
          disabled={disabled}
          className="phone-input"
          numberInputProps={{
            className: "phone-number-input",
            placeholder: placeholder || " ",
          }}
          countrySelectProps={{
            className: "phone-country-select",
          }}
        />
      </div>
      {error && errmsg && <div className="phone-error-text">{errmsg}</div>}
    </div>
  );
};

export default PhoneInput;
